// extracted by mini-css-extract-plugin
module.exports = {"container":"paginator_container__k0_z4","disabled":"paginator_disabled__Hgtsz","selected":"paginator_selected__ZwGQq","boldButton":"paginator_boldButton__LTVJP"};